export const getStudyAnalysesData = state => state.studyAnalyses.all;
export const getStudyAnalysisData = state => state.studyAnalyses.studyAnalysis;
export const studyAnalysesIsFetching = state => state.studyAnalyses.loading.all;
export const studyAnalysisIsFetching = state => state.studyAnalyses.loading.studyAnalysis;